import $ from "classnames";
import e, { useMemo as B } from "react";
import { PlainIconButton as S } from "../button/plain-icon-button.esm.js";
import k from "../icon/src/Close.esm.js";
import { TypographyComponent as c } from "../typography/typography-component.esm.js";
import "../typography/typography-config.esm.js";
import { useSizeAttrs as A } from "../utils/hooks/useSizeAttrs.esm.js";
import { HeadingSizeMap as i } from "./alert-config.esm.js";
const x = "_alert_1c5to_1", I = "_alert__heading_1c5to_42", j = "_alert__message_1c5to_51", z = "_alert__contentContainer_1c5to_61", H = "_alert__content_1c5to_61", M = "_alert__closeButton_1c5to_126", t = {
  alert: x,
  alert__heading: I,
  alert__message: j,
  alert__contentContainer: z,
  alert__content: H,
  alert__closeButton: M
}, { forwardRef: O, useCallback: R } = e, T = O(
  ({
    className: m,
    closable: r = !1,
    children: d,
    closeCallback: l = () => {
    },
    dataTestId: f,
    heading: n = "",
    message: s = "",
    disableIcon: u = !1,
    size: a = { xxs: "small", m: "medium", l: "large" },
    variant: _ = "information",
    ...g
  }, p) => {
    const { ...b } = g, [h, C] = e.useState(!1), v = R(
      (o) => {
        C(!0), l(o);
      },
      [l]
    ), E = B(
      () => typeof a == "string" ? i[a] : Object.fromEntries(
        Object.entries(a).map(([o, y]) => [o, i[y]])
      ),
      [a]
    ), N = A(a);
    return !h && /* @__PURE__ */ e.createElement(
      "div",
      {
        ref: p,
        className: $(t.alert, "fuse-alert", m),
        "data-testid": f || "fuse-alert",
        ...b,
        "data-variant": _,
        "data-closable": r ? "" : void 0,
        "data-no-icon": u ? "" : void 0,
        ...N
      },
      /* @__PURE__ */ e.createElement(
        "div",
        {
          className: `${t.alert__contentContainer} fuse-alert__content-container`,
          "data-testid": "fuse-alert__content-container"
        },
        /* @__PURE__ */ e.createElement(
          "div",
          {
            className: `${t.alert__content} fuse-alert__content`,
            "data-testid": "fuse-alert__content"
          },
          n && /* @__PURE__ */ e.createElement(
            c,
            {
              className: `${t.alert__heading} fuse-alert__heading`,
              type: "heading",
              size: E,
              tag: "h2",
              color: "var(--color-global-black)"
            },
            n
          ),
          s && /* @__PURE__ */ e.createElement(
            c,
            {
              className: `${t.alert__message} fuse-alert__message`,
              type: "paragraph",
              size: "m1",
              tag: "p",
              color: "var(--color-global-black)"
            },
            s
          ),
          d,
          r && /* @__PURE__ */ e.createElement(
            S,
            {
              className: `${t.alert__closeButton} fuse-alert__close-button`,
              dataTestId: "fuse-alert__close-button",
              icon: /* @__PURE__ */ e.createElement(k, null),
              callback: (o) => v(o),
              ariaLabel: `Close ${_} dialog`
            }
          )
        )
      )
    );
  }
);
T.displayName = "Alert";
export {
  T as Alert
};
